module.exports = __webpack_public_path__ + "img/service-orange.e9f376e9.svg";